import React from 'react';
import styled, { ThemeProvider } from 'styled-components';
import useTheme from '@material-ui/core/styles/useTheme';
import Tooltip from '@material-ui/core/Tooltip';
import HelpCircle from '../../../../icons/HelpCircle';
import { useTranslation } from 'react-i18next';
import SimpleDialog from '../../../dialogs/SimpleDialog/SimpleDialog';

type HowItWorksButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  iconSize?: 'normal' | 'small';
  src: string;
  hideLabel?: boolean;
};

export const HowItWorksButton = ({ iconSize, src, hideLabel, ...buttonProps }: HowItWorksButtonProps): JSX.Element => {
  const { t } = useTranslation();
  const theme = useTheme();
  const [dialog, setDialog] = React.useState<JSX.Element | undefined>(undefined);

  const html = `<div style="position:relative;padding-bottom:56.25%;"> <iframe style="width:100%;height:100%;position:absolute;left:0px;top:0px;border-radius: 10px" src="${src}" frameborder="0" referrerpolicy="unsafe-url" allowfullscreen="true" allow="clipboard-write" sandbox="allow-popups allow-popups-to-escape-sandbox allow-scripts allow-forms allow-same-origin allow-presentation"></iframe> </div>`;

  return (
    <ThemeProvider theme={theme}>
      <Tooltip title="" placement="right">
        <StyledButton
          className="flex items-center font-bold text-base ml-8 helpButton"
          {...buttonProps}
          onClick={() => {
            setDialog(
              <SimpleDialog
                cancelButtonText={t('Close')}
                open={true}
                handleClose={() => setDialog(undefined)}
                width="50rem"
              >
                <div dangerouslySetInnerHTML={{ __html: html }}></div>
              </SimpleDialog>,
            );
          }}
        >
          <div className={`help-circle-icon-wrapper ${iconSize === 'small' ? 'smallIcon' : ''}`}>
            <HelpCircle />
          </div>
          {!hideLabel && <span className="text-sm font-normal ml-1.5">{t('How it works')}</span>}
        </StyledButton>
      </Tooltip>
      {dialog}
    </ThemeProvider>
  );
};

const StyledButton = styled.button`
  span {
    color: #24b400;
  }
  .help-circle-icon-wrapper {
    svg {
      width: 1.75rem;
      height: 1.75rem;
    }
  }
  .help-circle-icon-wrapper.smallIcon {
    svg {
      width: 1.5rem;
      height: 1.5rem;
    }
  }
`;
